module.exports = __webpack_public_path__ + "img/09.7578f687.jpg";